import { schema } from 'normalizr';

export const printPageSchema = new schema.Entity('printPages', {});

export const partFileSchema = new schema.Entity(
  'partFiles',
  {
    printPages: [printPageSchema],
  },
  {
    idAttribute: 'uuid',
  },
);
